export const landingTitle = "IciAparts&Rooms";
export const landingMsg =
  "Quick Apartments and rooms in majors Europeans cities: Paris, Brussels,London etc...";
